<template>
  <div>
    <mtd-row class="margin-bottom-0">
      <mtd-col :span="24" class="height-full">
        <h2 class="dd-page-title">填写补充信息</h2>
      </mtd-col>
    </mtd-row>
    <mtd-announcement type="warning" style="margin-bottom: 12px" show-icon v-if="process_list.length === 1"
                      title="您所发文件密级较高，根据您组织的外发管理要求，需要完善下列信息。"/>
    <mtd-announcement type="warning" style="margin-bottom: 12px" show-icon v-if="process_list.length > 1"
                      title="您所发文件密级较高，根据您组织的外发管理要求，请选择外发流程。"/>
    <div>
      <div class="file-extra">
        <div style="background: #F7F7F7;padding: 6px 16px;">
          <div style="line-height: 24px;display: flex;align-items:center;">
            <h2 class="file-list-title2">上传的文件</h2>
          </div>
        </div>
        <div class="file-extra-content">
          <div v-for="item in file_list">
            {{ item.fileName }}
          </div>
        </div>
      </div>
      <div  class="file-extra" v-if="process_list.length !== 0">
        <div style="background: #F7F7F7;padding: 6px 16px;">
          <div style="line-height: 24px;display: flex;align-items:center;">
            <h2 class="file-list-title2">选择外发流程</h2>
          </div>
        </div>
        <div class="file-extra-content">
          <div>
            <mtd-radio-group v-model="selectedProcess" style="display: block">
              <div  v-for="item in process_list">
                <mtd-radio :value="item.id">{{ item.strategyName }}</mtd-radio>
              </div>
            </mtd-radio-group>
          </div>
        </div>
      </div>
    </div>
    <div>
      <mtd-row type="flex" justify="center">
        <mtd-col :span="24" style="text-align: center;margin-top: 24px">
          <mtd-button style="margin-right: 8px" size="large" @click="back_to_file_out">修改外发文件</mtd-button>
          <mtd-button type="primary" style="margin-left: 8px" @click="submit_out" size="large" :disabled="!submit">提交</mtd-button>
        </mtd-col>
      </mtd-row>
    </div>
  </div>
</template>

<script>

    import {mapActions} from "vuex";

    export default {
      name: "file_out_extra_info",
      data() {
        return {
          process_list:[],
          selectedProcess:'',
          outReason:'',
          file_list: [],
          back_file_list: [],
          emails:'',
          shared:{
            url:'',
            password:'',
            status:''
          }
        }
      },
      computed:{
        submit() {
          if (this.selectedProcess != '') {
            var vm = this;
            var index = this.process_list.findIndex(item => item.id === vm.selectedProcess);
            if (this.process_list[index].needsFileOutReason) {
              return this.outReason != '';
            } else {
              return true;
            }
          } else {
            return false;
          }
        },
        needs_file_out_reason() {
          var vm = this;
          var index = this.process_list.findIndex(item => item.id === vm.selectedProcess);
          return this.process_list[index].needsFileOutReason;
        }
      },
      mounted() {
        let arr = this.$route.params.result.files;
        let res = this.$route.params.result.results;
        if (arr != null && arr.length !== 0) {
          this.file_list = arr;
        }
        if (this.$route.params.scan_file_list != null && this.$route.params.scan_file_list.length !== 0) {
          this.back_file_list = this.$route.params.scan_file_list;
        }
        this.emails = this.$route.params.emails;
        this.process_list = res;
        if (this.process_list.length === 1) {
          this.selectedProcess = this.process_list[0].id;
        }
        this.outReason = this.$route.params.fileOutReason;
      },
      methods:{
        ...mapActions([
          'submitFileOutOrder',
          'submitFileOutOrderExemption'
        ]),
        back_to_file_out() {
          this.$router.push({ name:'file|outer|file_upload',params:{file_list: this.back_file_list}});
        },
        submit_out() {
          let vm = this;
          var index = this.process_list.findIndex(item => item.id == vm.selectedProcess);
          let strategyName = this.process_list[index].strategyName;
          let isExemption = this.process_list[index].isExemption;
          let param = {
            files: this.file_list,
            fileOutReason: this.outReason,
            id: this.selectedProcess,
            strategyName: strategyName,
            emails: this.emails
          };
          if (isExemption) {
            this.submitFileOutOrderExemption({
              emails: this.emails,
              files: this.file_list,
              fileOutReason: this.outReason,
            }).then(res => {
              let shared = res.data;
              let url = shared.url;
              let pass = shared.password;
              let info = `文件分享链接： ${url} \n提取密码：${pass}`;
              console.log(info);
              this.$router.push({name: 'file_out_completed', params: {shared: shared,emails: this.emails}});
            });
          } else {
            this.submitFileOutOrder(param).then(res => {
              this.shared.url = res.data.url;
              this.shared.password = res.data.password;
              this.shared.bpmDetails = res.data.bpmDetails;
              this.shared.status = res.data.status;
              this.shared.recordId = res.data.recordId;
              if (this.shared.url != null) {
                let url = this.shared.url;
                let pass = this.shared.password;
                let info = `文件分享链接： ${url} \n提取密码：${pass}`;
                console.log(info);
                this.$router.push({ name:'file_out_completed',params:{shared: this.shared}});
              }
            });
          }
        }
      }
    }
</script>

<style>
  .margin-bottom-0{
    margin-bottom: 0;
  }
  h2.dd-page-title{
    font-size: 20px;
    line-height: 32px;
    margin-bottom: 16px;
  }
  h2.file-list-title2{
    font-size: 14px;
    line-height: 24px;
  }
  .file-extra{
    border: 1px solid rgba(0,0,0,0.07);
    border-radius: 4px;
    margin-bottom: 8px;
  }
  .file-extra-content{
    padding: 12px 16px;
  }
</style>
